import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Button, Skeleton } from 'antd'
import PageLayout from '@BUP/components/Layout/Page'
import { getFetcher } from '@BUP/services/Axios'
import AlertComponent from '@BUP/components/Generics/Alert'
import { ComplaintDescriptions } from '@BUP/components/complaint/descriptions'
import { useTranslation } from 'react-i18next'
import { DownloadOutlined } from '@ant-design/icons'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { ComplaintPDF } from '@BUP/components/complaint/pdf-complaint' // Importa el documento PDF
import styles from './show.module.scss'
import AlertInfoNotification from './alertInfoNotification'

export const LogbookShowComplaintPage = () => {
  const { t } = useTranslation()
  const { complaintId } = useParams()
  const { data, isLoading: isLoadingComplaint, error, mutate } = useSWR(
    `/complaints/${complaintId}?include=complaintEntries`,
    getFetcher,
    {
      errorRetryCount: 3,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  if (!data) return null

  const content = error
    ? (
      <AlertComponent
        type='error'
        message={t('common.resources.generic.actions.any.failure', { context: 'try-again' })}
      />
      )
    : (
      <>
        {data.state === 'closed'
          ? (
            <div className={styles.closed_complaint_banner}>
              <PDFDownloadLink
                document={<ComplaintPDF complaint={data} />}
                fileName={`${(data.title).replace(/\s+/g, '-')}_${new Date().toLocaleDateString('es-CL')}.pdf`}
                className={styles.download_button}
              >
                {({ loading }) =>
                  loading
                    ? 'Cargando documento...'
                    : <Button type='primary' icon={<DownloadOutlined />}>Descargar</Button>}
              </PDFDownloadLink>
            </div>
            )
          : (
            <AlertInfoNotification />
            )}
        <div>
          <ComplaintDescriptions complaint={data} mutate={mutate} />
        </div>
      </>
      )

  return (
    <PageLayout backButton pageName={t('common.resources.complaint.label', { count: 1 })}>
      <Skeleton loading={isLoadingComplaint}>
        <div className={styles.content_wrapper}>
          {content}
        </div>
      </Skeleton>
    </PageLayout>
  )
}
